export const KPIFieldType = {
   TEXTAREA: 'TEXTAREA',
   PRICE: 'PRICE',
   TEXT: 'TEXT',
   PERCENTAGE: 'PERCENTAGE',
   SELECT: 'SELECT',
   NUMBER: 'NUMBER',
   SURFACE: 'SURFACE',
   EMISSIONS: 'EMISSIONS',
   DATE: 'DATE',
   DISTANCE: 'DISTANCE',
   VOLUME: 'VOLUME',
   ELECTRICITY: 'ELECTRICITY',
   WEIGHT: 'WEIGHT',
   MEASUREMENT: 'MEASUREMENT',
   FORMULA: 'FORMULA',
   DATA: 'DATA',
   SWITCH: 'SWITCH',
   WOOD: 'WOOD',
   EMISSION_SELECT: 'EMISSION_SELECT',
   TABLE: 'TABLE',
   TIME: 'TIME',
   POWER: 'POWER',
   SURFACE_TIME: 'SURFACE_TIME',
   CONTAINER_DISTANCE: 'CONTAINER_DISTANCE',
   DATA_TIME: 'DATA_TIME',
   NUMBER_TIME: 'NUMBER_TIME',
   PASSENGER_DISTANCE: 'PASSENGER_DISTANCE',
   WEIGHT_TIME: 'WEIGHT_TIME',
   WEIGHT_DISTANCE: 'WEIGHT_DISTANCE',
} as const;
export type KPIFieldTypeEnum = (typeof KPIFieldType)[keyof typeof KPIFieldType];

export const numericFields = [
   KPIFieldType.WEIGHT,
   KPIFieldType.SURFACE,
   KPIFieldType.PRICE,
   KPIFieldType.MEASUREMENT,
   KPIFieldType.EMISSIONS,
   KPIFieldType.EMISSION_SELECT,
   KPIFieldType.DISTANCE,
   KPIFieldType.ELECTRICITY,
   KPIFieldType.VOLUME,
   KPIFieldType.PERCENTAGE,
   KPIFieldType.NUMBER,
   KPIFieldType.DATA,
   KPIFieldType.FORMULA,
   KPIFieldType.WOOD,
   KPIFieldType.TIME,
   KPIFieldType.POWER,
   KPIFieldType.CONTAINER_DISTANCE,
   KPIFieldType.DATA_TIME,
   KPIFieldType.NUMBER_TIME,
   KPIFieldType.PASSENGER_DISTANCE,
   KPIFieldType.WEIGHT_TIME,
   KPIFieldType.WEIGHT_DISTANCE,
   KPIFieldType.SURFACE_TIME,
] as const;

export function fieldTypeIsNumeric(kpiFieldType?: KPIFieldTypeEnum): boolean {
   if (!kpiFieldType) {
      return false;
   }

   return (numericFields as readonly KPIFieldTypeEnum[]).includes(kpiFieldType);
}
